import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var VendorsService = /** @class */ (function () {
    function VendorsService(http) {
        this.http = http;
    }
    VendorsService.prototype.getVendorList = function (appId) {
        var env = 'production';
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor?env=' + env;
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.prototype.addVendor = function (_vendorData) {
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor';
        return this.http.put(url, _vendorData).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.prototype.updateVendor = function (_vendorData) {
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor';
        return this.http.post(url, _vendorData).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.prototype.deleteVendor = function (_vendorId) {
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor/delete?vid=' + _vendorId;
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.prototype.attachVendor = function (vendor_ids, app_id) {
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor/update';
        var payload = {
            vend_ids: vendor_ids,
            apid: app_id
        };
        return this.http.post(url, payload).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.prototype.getPushcredentials = function (appId) {
        var env = 'production';
        var _this = this;
        var url = '/dashboard/ujmanalytics/vendor/pushcredentials';
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    VendorsService.ngInjectableDef = i0.defineInjectable({ factory: function VendorsService_Factory() { return new VendorsService(i0.inject(i1.HttpClient)); }, token: VendorsService, providedIn: "root" });
    return VendorsService;
}());
export { VendorsService };
